import React from "react";
import "./TrabajoARealizar.css";

const TrabajoARealizar = ({ seccion, renderCase, updateItemResponse }) => {
  // Ordenar los items por orden si está disponible
  const sortedItems = seccion && seccion.items 
    ? [...seccion.items].sort((a, b) => (a.orden || 0) - (b.orden || 0)) 
    : [];

  return (
    <div className="sr-section">
      <p className="sr-section-title">{seccion.nombreseccion}</p>
      <div className="tr-section">
      {sortedItems.map((item) => (
        <Item 
          key={item.id} 
          item={item} 
          renderCase={renderCase}
          seccionId={seccion.idseccionreporte}
          updateItemResponse={updateItemResponse}
        />
      ))}
      </div>
    </div>
  );
};

const Item = ({ item, renderCase, seccionId, updateItemResponse }) => {
  // Determinar si el item requiere input (idtipoitem = 1 y tiene idtiporespuesta)
  const requiereInput = item.idtipoitem === 1 && item.idtiporespuesta;
  
  // Si no requiere input (no es de tipo 1), solo mostrar el texto
  if (!requiereInput) {
    return (
      <div className="tr-item tr-item-label">
        <p className={item.textbold ? "tr-item-bold" : ""}>{item.descripcion}</p>
      </div>
    );
  }

  // Si requiere input, mostrar con el input correspondiente
  return (
    <div className="tr-item">
      {/* Mostrar descripción y respuesta juntas en modo visualización (View) */}
      {renderCase !== "create" && renderCase !== "newFormat" ? (
        <div className="tr-inline-display">
          <span className={item.textbold ? "tr-item-bold" : ""}>{item.descripcion}</span>
          <span className="tr-response">
            <ItemInput 
              item={item} 
              renderCase={renderCase} 
              seccionId={seccionId}
              updateItemResponse={updateItemResponse}
            />
          </span>
        </div>
      ) : renderCase === "create" ? (
        <>
          <p className={item.textbold ? "tr-item-bold" : ""}>{item.descripcion}</p>
          <ItemInput 
            item={item} 
            renderCase={renderCase} 
            seccionId={seccionId}
            updateItemResponse={updateItemResponse}
          />
        </>
      ) : (
        // newFormat
        <>
          <p className={item.textbold ? "tr-item-bold" : ""}>{item.descripcion}</p>
          <div className="tr-new-format">
            <ItemInput 
              item={item} 
              renderCase={renderCase} 
              seccionId={seccionId}
              updateItemResponse={updateItemResponse}
            />
          </div>
        </>
      )}
    </div>
  );
};

const ItemInput = ({ item, renderCase, seccionId, updateItemResponse }) => {
  // Manejador para actualizar las respuestas de los items
  const handleItemChange = (value) => {
    if (updateItemResponse) {
      updateItemResponse(
        seccionId,
        item.id,
        item.idrespuestaitem,
        item.idrespuestabooleana,
        item.idrespuestanumerica,
        item.idrespuestatexto,
        item.idrespuestaimagen,
        value
      );
    }
  };

  // Modo de creación
  if (renderCase === "create") {
    switch (item.idtiporespuesta) {
      case 1: // Booleano
        return (
          <div className="tr-checkbox-container">
            <label>
              <input
                type="checkbox"
                checked={item.respuesta === true}
                onChange={() => handleItemChange(true)}
              />{" "}
              Sí
            </label>
            <label>
              <input
                type="checkbox"
                checked={item.respuesta === false}
                onChange={() => handleItemChange(false)}
              />{" "}
              No
            </label>
            <label>
              <input
                type="checkbox"
                checked={item.respuesta === null}
                onChange={() => handleItemChange(null)}
              />{" "}
              N/A
            </label>
          </div>
        );
      case 2: // Numérico
        return (
          <input
            type="number"
            className="tr-input-report"
            value={item.respuesta || ""}
            onChange={(e) => handleItemChange(e.target.value)}
            placeholder="Valor"
          />
        );
      case 3: // Texto
        return (
          <input
            type="text"
            className="tr-input-report"
            value={item.respuesta || ""}
            onChange={(e) => handleItemChange(e.target.value)}
            placeholder="Texto"
          />
        );
      default:
        return <span>{item.respuesta || ""}</span>;
    }
  } 
  // Modo de formato nuevo (visualización especial)
  else if (renderCase === "newFormat") {
    switch (item.idtiporespuesta) {
      case 1: // Boolean
        return (
          <>
            <input type="checkbox" checked={item.respuesta === true} readOnly />{" "}
            {item.respuesta === true ? "OK" : item.respuesta === false ? "N/G" : "N/A"}
          </>
        );
      case 2: // Numeric
        return <span>{item.respuesta !== null ? item.respuesta : ""}</span>;
      case 3: // Text
        return <span>{item.respuesta !== null ? item.respuesta : ""}</span>;
      default:
        return <span>{item.respuesta !== null ? item.respuesta : ""}</span>;
    }
  } 
  // Modo de visualización estándar
  else {
    switch (item.idtiporespuesta) {
      case 1: // Boolean
        return item.respuesta === true ? "Sí" : item.respuesta === false ? "No" : "N/A";
      case 2: // Numeric
      case 3: // Text
      default:
        return <span>{item.respuesta !== null ? item.respuesta : ""}</span>;
    }
  }
};

export default TrabajoARealizar;